import { render } from "./SpecialistsBrowser.vue?vue&type=template&id=6c4a1270&scoped=true"
import script from "./SpecialistsBrowser.vue?vue&type=script&lang=js"
export * from "./SpecialistsBrowser.vue?vue&type=script&lang=js"

import "./SpecialistsBrowser.vue?vue&type=style&index=0&id=6c4a1270&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4a1270"]])

export default __exports__